export default from './RegionTooltip'


// WEBPACK FOOTER //
// ./src/components/search/FormElements/tooltips/RegionTooltip/index.js